<div class="body-container">
    <div class="text-container">
        <div>{{ 'version.create.dialog.updates.text' | translate }}</div>
        <ul class="list">
            <li class="list-item">
                {{ 'version.create.dialog.updates.option1' | translate }}
            </li>
            <li class="list-item">
                {{ 'version.create.dialog.updates.option2' | translate }}
            </li>
            <li class="list-item">
                {{ 'version.create.dialog.updates.option3' | translate }}
            </li>
        </ul>
    </div>
    <div class="options-container">
        <div
            class="option"
            data-cy="version-new-version-ops-yes-option"
            [ngClass]="{ selected: isMajorUpdate }"
            (click)="handleOptionSelected(true)">
            <mat-icon svgIcon="check" class="icon" />
            <div>{{ 'version.create.dialog.updates.yes' | translate }}</div>
        </div>
        <div
            class="option"
            data-cy="version-new-version-ops-no-option"
            [ngClass]="{ selected: isMajorUpdate === false }"
            (click)="handleOptionSelected(false)">
            <mat-icon svgIcon="close" class="icon" />
            <div>{{ 'version.create.dialog.updates.no' | translate }}</div>
        </div>
    </div>
</div>
